<template>
  <v-navigation-drawer
    v-model="visible"
    :mini-variant.sync="miniActivo"
    v-on:update:mini-variant="emitToggleMini"
    @mouseover.native="hover=true"
    @mouseleave.native="hover=false"
    fixed
    app
    width="247"
  >
    <div id="logos">
      <img id="logoTecisaMini" src="/assets/logoTecisaMini.png" />
      <img id="logoTecisa" src="/assets/logoTecisa.png" />
    </div>

    <!-- Ejemplo de maquetación de un item
    
      <v-list dense class="pt-0 children">
      <v-list-item to="/home">
        <v-list-item-icon>
          <v-icon>home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>-->
<v-divider class="hrLogo"></v-divider>
    <div id="menuIzq">
      <template v-for="item in itemsVisibles">
        <v-list :key="item.text" dense class="pt-0 children" top v-if="item.items.length == 0">
          <v-list-item :to="{path: item.url, params: item.props}" v-show="item.visible">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <template v-if="item.items.length > 0">
          <v-list-group :key="item.text" :value="item.expand">
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              dense
              v-for="subItem in item.items"
              :key="subItem.text"
              :to="{path: subItem.url}"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="subItem.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from "vuex";
// top drawer
import TopDrawer from "@/components/layout/topdrawer";

export default {
  components: {
    TopDrawer
  },
  computed: {
    ...mapState("global", ["drawer", "mini"]),
    user: function() {
      return this.$store.state.authentication.user;
    },
    visible: {
      get: function() {
        return this.drawer;
      },
      set: function(visible) {
        this.$emit("toggle_drawer", visible);
      }
    },
    // itemsVisibles: function() {
    //   return this.items.filter(function(u) {
    //     return u.visible;
    //   });
    // },
    itemsVisibles() {
    return this.items.filter(item => {
      // Si el item es exclusivo para admin, retorna solo si el usuario es admin
      if (item.adminOnly) {
        return this.user && this.user.isAdmin;
      }
      // En otros casos, se respeta el valor de visible definido en cada item
      return item.visible;
    });
  },
    miniActivo: function() {
      return !this.hover && this.mini;
    },
    
  },
  data() {
    return {
      items: [
        {
          icon: "home",
          text: "Inicio",
          url: "/",
          name: "inicio",
          visible: true,
          items: []
        },
        {
          icon: "chat_bubble",
          text: "Fichar",
          url: "/fichar",
          name: "fichar",
          visible: true,
          items: []
        },
        {
          icon: "chat",
          text: "Fichar con incidencia",
          url: "/fichar-incidencia",
          name: "inicio",
          visible: true,
          items: []
        },
        {
          icon: "history",
          text: "Consultar Fichajes",
          url: "/consultar-fichajes",
          name: "inicio",
          visible: true,
          items: []
        },
        {
          icon: "contact_support",
          text: "Preguntas frecuentes",
          url: "/faqs",
          name: "inicio",
          visible: true,
          items: []
        },
        {
          icon: "map",
          text: "Configurar localización",
          url: "/geolocation-config",
          name: "inicio",
          visible: true ,
          items: [],
          adminOnly: true,
        },
        
      ],
      hover: false,
      
    };
  },
  methods: {
    ...mapMutations("global", ["SET_DRAWER"]),
    test: function() {},
    emitToggleMini: function() {
      this.$emit("toggleMini", !this.mini);
    },
    mouseOver: function() {
      alert("aaa");
    },
  }
};
</script>
<style>
.v-application .v-navigation-drawer #menuIzq .v-list-group > .v-list-item.v-list-item--active{
}
</style>
<style lang="scss">
.v-application .v-navigation-drawer {
  .primary--text {
  }

  &.v-navigation-drawer--mini-variant {
    .v-list-group__header__append-icon {
      display: inline-block !important;
    }
    .v-list-group .v-list-item__icon {
      display: none;
    }
    .v-list-group__items {
      display: inline-block;
    }
  }

  #menuIzq {
    .v-list:first-child {
      margin-top: px;
    }

    .v-list-group {

      &.v-list-group--active {

        &.v-list-group__header.v-list-item {
          

          &.v-list-item--active .v-list-item__title {
          }

          .v-list-item--active {
            font-size: 20px !important;
          }
        }

      }
      .v-list-group__header {
        &.v-list-group__header__append-icon {
          min-width: 24px !important;
        }
      }
    }

    .v-list-item{
      &.v-list-item--active{
          color: var(--v-primary-base);
      }
    }
  }
}
</style>

<style >
</style>
<style scoped>
.v-navigation-drawer .v-list-group {
}

.v-navigation-drawer .v-list-group .v-list-item__icon {
  display: none;
}

.v-navigation-drawer .v-list-group .v-list-group__items .v-list-item__icon {
  display: inline-block;
}

.v-navigation-drawer #logoTecisa {
  display: block;
  margin: 0 auto;
  margin-top: 14px;
}
.v-navigation-drawer.v-navigation-drawer--mini-variant #logoTecisa {
  display: none;
}
.v-navigation-drawer #logoTecisaMini,
.v-navigation-drawer--mini-variant .v-list__tile__title {
  display: none;
}

.v-navigation-drawer.v-navigation-drawer--mini-variant #logoTecisaMini {
  display: block;
  margin: 0 auto;
  margin-top: 14px;
}

.v-navigation-drawer .v-list--dense {
  padding-top: 0;
  padding-bottom: 0;
}

.v-navigation-drawer .v-list--dense .v-subheader,
.v-navigation-drawer .v-list-item__title {
  font-size: 0.8125rem;
}

.v-navigation-drawer .v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 16px;
}

.theme--dark.v-list .primary--text .v-list__tile__title,
.theme--dark.v-icon {
  color: #fff !important;
}

.v-list__tile__action,
.v-list__tile__avatar {
  min-width: 40px;
}

.v-navigation-drawer
  .v-list-group--no-action
  > .v-list-group__items
  > div
  > .v-list-item {
  padding-left: 16px;
}

.v-navigation-drawer >>> .v-list__group__items--no-action .v-list__tile {
  padding-left: 57px;
  position: relative;
}

.v-list-item--link:before{
    background-color: #fff;
}

.v-navigation-drawer >>> .v-list__tile--active {
  background: #1e88e5;
}

/* .v-navigation-drawer >>> .v-list__tile--active:before {
  font-family: "Material Icons";
  content: "keyboard_arrow_right";
  font-size: 1.2rem;
  position: absolute;
  top: 7px;
  left: 40px;
  color: #fff;
} */

.v-navigation-drawer.v-navigation-drawer--mini-variant
  >>> .v-list__tile--active:before {
  content: "";
}

.v-navigation-drawer.v-navigation-drawer--mini-variant
  >>> .v-list__tile--active {
  background: transparent;
}

.v-navigation-drawer .v-list__group__items .v-list__tile__title {
  font-weight: 400;
}
</style>

<style>
.v-list__group__header .v-list__group__header__append-icon {
  padding: 0 4px !important;
}
.v-divider.hrLogo {
  margin-bottom: 15px;
  margin-top: 16px;
  border-color: rgba(0,0,0,0.05);
}
.v-navigation-drawer--mini-variant .v-divider.hrLogo {
  display: block !important;
  margin-bottom: 10px;
}
</style>